import { useEffect, useState } from 'react';

/**
 * Live `prefers-reduced-motion` state. Mirrors the matchMedia pattern used in
 * HoloRoleCard so every FX surface honours the OS toggle the same way and reacts
 * to it changing mid-session. Under reduced motion the particle engine renders
 * nothing and shakes degrade to a flash.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduced(mq.matches);
    const h = (e: MediaQueryListEvent) => setReduced(e.matches);
    mq.addEventListener('change', h);
    return () => mq.removeEventListener('change', h);
  }, []);
  return reduced;
}

/** Non-reactive read for imperative code (the burst bus). */
export function prefersReducedMotion(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}
